var map = {
	"./favicon.png": 274,
	"./index.html": 275,
	"./logo.svg": 276,
	"./manifest": 109,
	"./manifest.json": 109,
	"./offline": 110,
	"./offline.html": 277,
	"./offline.json": 110
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;


//////////////////
// WEBPACK FOOTER
// ./client/static ^\.\/.*$
// module id = 273
// module chunks = 0